import React from "react";
import {
  withStyles,
  Switch,
  FormControl,
  FormHelperText,
  Typography,
  Box,
} from "@material-ui/core";
import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import Error from "../Error/Error";
import { green, grey } from "../../constants/colors"

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  switchBase: {
    padding: 1,
    "& + $track": {
      backgroundColor: grey,
      opacity: 0.3,
      transition: "all 0.3s ease",
    },

    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: green,
        opacity: 1,
        border: "none",
        transition: "all 0.3s ease",
      },
    },
    "&$focusVisible $thumb": {
      color: green,
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export const CustomSwitch = ({ ...props }) => {
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";
  const disabled = props?.disabled || false;
  return (
    <FormControl error={!!errorText}>
      <Box component="label" style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} display="flex" alignItems="flex-start">
        <Controller
          {...props}
          defaultValue={props.value}
          control={control}
          render={(props) => (
            <IOSSwitch
              disabled={disabled}
              checked={props.value}
              onChange={(e) => {
                props.onChange(e.target.checked);
              }}
            />
          )}
        />
        <Typography variant="body2">{props.label}</Typography>
      </Box>
      <FormHelperText>
        {errorText && <Error errorMessage={errorText} />}
      </FormHelperText>
    </FormControl>
  );
};
